<div class="leading-snug text-gray-500">
  Zapisz się do naszego newslettera, aby być na bieżąco z nowymi edycjami i
  informacjami ze świata PureBeauty.
</div>
